import { render, staticRenderFns } from "./ChangePhotoPopup.vue?vue&type=template&id=fab827ca&scoped=true&"
import script from "./ChangePhotoPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangePhotoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePhotoPopup.vue?vue&type=style&index=0&id=fab827ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab827ca",
  null
  
)

export default component.exports